/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClinicCreatedResponse,
  ClinicDirectoryDto,
  ClinicResponse,
  ClinicVerificationResponse,
  ClinicVerificationStateResponse,
  ClinicsSlugAvailableParams,
  CreateClinicDto,
  OnboardingStateResponse,
  SlugAvailabilityResponse,
  SubmitVerificationDto,
  UpdateClinicDto,
  UpdateClinicSettingsDto,
  UploadTicketResponse,
  VerificationUploadUrlDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * کلینیک را با دورهٔ آزمایشی می‌سازد و شما را مالک آن ثبت می‌کند. توکن فعلی هنوز به کلینیک قبلی محدود است؛ پس از ساخت، POST /auth/switch-clinic را صدا بزنید تا توکن کلینیک تازه صادر شود.
 * @summary ساخت کلینیک تازه
 */
export const clinicsCreate = (
    createClinicDto: CreateClinicDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicCreatedResponse>(
      {url: `/api/v1/clinics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClinicDto, signal
    },
      );
    }




export const getClinicsCreateMutationKey = () => ['clinicsCreate'] as const;

export const getClinicsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsCreate>>, TError,ClinicsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsCreate>>, TError,ClinicsCreateMutationVariables, TContext> => {

const mutationKey = getClinicsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsCreate>>, ClinicsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsCreate>>>
    export type ClinicsCreateMutationBody = CreateClinicDto
    export type ClinicsCreateMutationError = void
    export type ClinicsCreateMutationVariables = {data: CreateClinicDto}

    /**
 * @summary ساخت کلینیک تازه
 */
export const useClinicsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsCreate>>, TError,ClinicsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsCreate>>,
        TError,
        ClinicsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsCreateMutationOptions(options), queryClient);
    }
    /**
 * نشانی اینترنتی صفحهٔ عمومی در کل سامانه یکتاست. اگر گرفته شده باشد، نزدیک‌ترین نشانی آزاد پیشنهاد می‌شود.
 * @summary بررسی آزاد بودن نشانی اینترنتی
 */
export const clinicsSlugAvailable = (
    params: ClinicsSlugAvailableParams,
 signal?: AbortSignal
) => {


      return apiClient<SlugAvailabilityResponse>(
      {url: `/api/v1/clinics/slug-available`, method: 'GET',
        params, signal
    },
      );
    }




export const getClinicsSlugAvailableQueryKey = (params?: ClinicsSlugAvailableParams,) => {
    return [
    `/api/v1/clinics/slug-available`, ...(params ? [params] : [])
    ] as const;
    }


export const getClinicsSlugAvailableQueryOptions = <TData = Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError = void>(params: ClinicsSlugAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicsSlugAvailableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicsSlugAvailable>>> = ({ signal }) => clinicsSlugAvailable(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicsSlugAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof clinicsSlugAvailable>>>
export type ClinicsSlugAvailableQueryError = void


export function useClinicsSlugAvailable<TData = Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError = void>(
 params: ClinicsSlugAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsSlugAvailable>>,
          TError,
          Awaited<ReturnType<typeof clinicsSlugAvailable>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsSlugAvailable<TData = Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError = void>(
 params: ClinicsSlugAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsSlugAvailable>>,
          TError,
          Awaited<ReturnType<typeof clinicsSlugAvailable>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsSlugAvailable<TData = Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError = void>(
 params: ClinicsSlugAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary بررسی آزاد بودن نشانی اینترنتی
 */

export function useClinicsSlugAvailable<TData = Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError = void>(
 params: ClinicsSlugAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsSlugAvailable>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicsSlugAvailableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همهٔ اطلاعات کلینیکی که توکن شما به آن محدود است: مشخصات عمومی، موقعیت جغرافیایی، قواعد نوبت‌دهی، وضعیت تأیید و تنظیمات.
 * @summary مشخصات کلینیک جاری
 */
export const clinicsCurrent = (

 signal?: AbortSignal
) => {


      return apiClient<ClinicResponse>(
      {url: `/api/v1/clinics/current`, method: 'GET', signal
    },
      );
    }




export const getClinicsCurrentQueryKey = () => {
    return [
    `/api/v1/clinics/current`
    ] as const;
    }


export const getClinicsCurrentQueryOptions = <TData = Awaited<ReturnType<typeof clinicsCurrent>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicsCurrentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicsCurrent>>> = ({ signal }) => clinicsCurrent(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicsCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof clinicsCurrent>>>
export type ClinicsCurrentQueryError = void


export function useClinicsCurrent<TData = Awaited<ReturnType<typeof clinicsCurrent>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsCurrent>>,
          TError,
          Awaited<ReturnType<typeof clinicsCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsCurrent<TData = Awaited<ReturnType<typeof clinicsCurrent>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsCurrent>>,
          TError,
          Awaited<ReturnType<typeof clinicsCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsCurrent<TData = Awaited<ReturnType<typeof clinicsCurrent>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مشخصات کلینیک جاری
 */

export function useClinicsCurrent<TData = Awaited<ReturnType<typeof clinicsCurrent>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicsCurrentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فقط فیلدهای ارسالی تغییر می‌کنند. شماره‌ها، کد پستی، رایانامه و شمارهٔ پروانه پیش از ذخیره یکسان‌سازی می‌شوند. وضعیت اشتراک، وضعیت تأیید و انتشار صفحهٔ عمومی از این مسیر قابل تغییر نیستند.
 * @summary ویرایش مشخصات کلینیک
 */
export const clinicsUpdate = (
    updateClinicDto: UpdateClinicDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicResponse>(
      {url: `/api/v1/clinics/current`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClinicDto, signal
    },
      );
    }




export const getClinicsUpdateMutationKey = () => ['clinicsUpdate'] as const;

export const getClinicsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdate>>, TError,ClinicsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdate>>, TError,ClinicsUpdateMutationVariables, TContext> => {

const mutationKey = getClinicsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsUpdate>>, ClinicsUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsUpdate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsUpdate>>>
    export type ClinicsUpdateMutationBody = UpdateClinicDto
    export type ClinicsUpdateMutationError = void
    export type ClinicsUpdateMutationVariables = {data: UpdateClinicDto}

    /**
 * @summary ویرایش مشخصات کلینیک
 */
export const useClinicsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdate>>, TError,ClinicsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsUpdate>>,
        TError,
        ClinicsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsUpdateMutationOptions(options), queryClient);
    }
    /**
 * ادغام سطحی با تنظیمات فعلی؛ مقدار null یک کلید را حذف می‌کند. برای ترجیح‌های نمایشی پنل است، نه برای داده‌ای که ستون اختصاصی دارد.
 * @summary ویرایش تنظیمات آزاد کلینیک
 */
export const clinicsUpdateSettings = (
    updateClinicSettingsDto: UpdateClinicSettingsDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicResponse>(
      {url: `/api/v1/clinics/current/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClinicSettingsDto, signal
    },
      );
    }




export const getClinicsUpdateSettingsMutationKey = () => ['clinicsUpdateSettings'] as const;

export const getClinicsUpdateSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdateSettings>>, TError,ClinicsUpdateSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdateSettings>>, TError,ClinicsUpdateSettingsMutationVariables, TContext> => {

const mutationKey = getClinicsUpdateSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsUpdateSettings>>, ClinicsUpdateSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsUpdateSettings(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsUpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsUpdateSettings>>>
    export type ClinicsUpdateSettingsMutationBody = UpdateClinicSettingsDto
    export type ClinicsUpdateSettingsMutationError = void
    export type ClinicsUpdateSettingsMutationVariables = {data: UpdateClinicSettingsDto}

    /**
 * @summary ویرایش تنظیمات آزاد کلینیک
 */
export const useClinicsUpdateSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsUpdateSettings>>, TError,ClinicsUpdateSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsUpdateSettings>>,
        TError,
        ClinicsUpdateSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsUpdateSettingsMutationOptions(options), queryClient);
    }
    /**
 * انتشار فقط پس از تأیید پروانهٔ پزشکی توسط مدیر سامانه ممکن است. برداشتن صفحه همیشه و بدون معطلی انجام می‌شود.
 * @summary انتشار یا برداشتن صفحهٔ عمومی کلینیک
 */
export const clinicsSetDirectory = (
    clinicDirectoryDto: ClinicDirectoryDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicResponse>(
      {url: `/api/v1/clinics/current/directory`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: clinicDirectoryDto, signal
    },
      );
    }




export const getClinicsSetDirectoryMutationKey = () => ['clinicsSetDirectory'] as const;

export const getClinicsSetDirectoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsSetDirectory>>, TError,ClinicsSetDirectoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsSetDirectory>>, TError,ClinicsSetDirectoryMutationVariables, TContext> => {

const mutationKey = getClinicsSetDirectoryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsSetDirectory>>, ClinicsSetDirectoryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsSetDirectory(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsSetDirectoryMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsSetDirectory>>>
    export type ClinicsSetDirectoryMutationBody = ClinicDirectoryDto
    export type ClinicsSetDirectoryMutationError = void
    export type ClinicsSetDirectoryMutationVariables = {data: ClinicDirectoryDto}

    /**
 * @summary انتشار یا برداشتن صفحهٔ عمومی کلینیک
 */
export const useClinicsSetDirectory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsSetDirectory>>, TError,ClinicsSetDirectoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsSetDirectory>>,
        TError,
        ClinicsSetDirectoryMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsSetDirectoryMutationOptions(options), queryClient);
    }
    /**
 * هر بار از روی داده‌های واقعی کلینیک محاسبه می‌شود، نه از روی یک نشانگر ذخیره‌شده؛ پس اگر تعرفه‌ای از صفحهٔ خدمات ثبت شود، همین‌جا هم انجام‌شده دیده می‌شود.
 * @summary وضعیت چک‌لیست راه‌اندازی
 */
export const clinicsOnboardingState = (

 signal?: AbortSignal
) => {


      return apiClient<OnboardingStateResponse>(
      {url: `/api/v1/clinics/current/onboarding`, method: 'GET', signal
    },
      );
    }




export const getClinicsOnboardingStateQueryKey = () => {
    return [
    `/api/v1/clinics/current/onboarding`
    ] as const;
    }


export const getClinicsOnboardingStateQueryOptions = <TData = Awaited<ReturnType<typeof clinicsOnboardingState>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicsOnboardingStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicsOnboardingState>>> = ({ signal }) => clinicsOnboardingState(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicsOnboardingStateQueryResult = NonNullable<Awaited<ReturnType<typeof clinicsOnboardingState>>>
export type ClinicsOnboardingStateQueryError = unknown


export function useClinicsOnboardingState<TData = Awaited<ReturnType<typeof clinicsOnboardingState>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsOnboardingState>>,
          TError,
          Awaited<ReturnType<typeof clinicsOnboardingState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsOnboardingState<TData = Awaited<ReturnType<typeof clinicsOnboardingState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsOnboardingState>>,
          TError,
          Awaited<ReturnType<typeof clinicsOnboardingState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsOnboardingState<TData = Awaited<ReturnType<typeof clinicsOnboardingState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت چک‌لیست راه‌اندازی
 */

export function useClinicsOnboardingState<TData = Awaited<ReturnType<typeof clinicsOnboardingState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsOnboardingState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicsOnboardingStateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * تا وقتی مرحله‌ای الزامی ناتمام باشد پذیرفته نمی‌شود. صدا زدن دوباره بی‌اثر است و تاریخ اولین تکمیل حفظ می‌شود.
 * @summary بستن چک‌لیست راه‌اندازی
 */
export const clinicsCompleteOnboarding = (

 signal?: AbortSignal
) => {


      return apiClient<OnboardingStateResponse>(
      {url: `/api/v1/clinics/current/onboarding/complete`, method: 'POST', signal
    },
      );
    }




export const getClinicsCompleteOnboardingMutationKey = () => ['clinicsCompleteOnboarding'] as const;

export const getClinicsCompleteOnboardingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsCompleteOnboarding>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsCompleteOnboarding>>, TError,void, TContext> => {

const mutationKey = getClinicsCompleteOnboardingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsCompleteOnboarding>>, void> = () => {


          return  clinicsCompleteOnboarding()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsCompleteOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsCompleteOnboarding>>>

    export type ClinicsCompleteOnboardingMutationError = void


    /**
 * @summary بستن چک‌لیست راه‌اندازی
 */
export const useClinicsCompleteOnboarding = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsCompleteOnboarding>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsCompleteOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClinicsCompleteOnboardingMutationOptions(options), queryClient);
    }
    /**
 * وضعیت فعلی، آخرین درخواست و تاریخچهٔ بررسی‌ها. در صورت رد شدن، دلیل بررسی‌کننده در decisionNote آمده است.
 * @summary وضعیت تأیید مدارک
 */
export const clinicsVerificationState = (

 signal?: AbortSignal
) => {


      return apiClient<ClinicVerificationStateResponse>(
      {url: `/api/v1/clinics/current/verification`, method: 'GET', signal
    },
      );
    }




export const getClinicsVerificationStateQueryKey = () => {
    return [
    `/api/v1/clinics/current/verification`
    ] as const;
    }


export const getClinicsVerificationStateQueryOptions = <TData = Awaited<ReturnType<typeof clinicsVerificationState>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicsVerificationStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicsVerificationState>>> = ({ signal }) => clinicsVerificationState(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicsVerificationStateQueryResult = NonNullable<Awaited<ReturnType<typeof clinicsVerificationState>>>
export type ClinicsVerificationStateQueryError = unknown


export function useClinicsVerificationState<TData = Awaited<ReturnType<typeof clinicsVerificationState>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsVerificationState>>,
          TError,
          Awaited<ReturnType<typeof clinicsVerificationState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsVerificationState<TData = Awaited<ReturnType<typeof clinicsVerificationState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicsVerificationState>>,
          TError,
          Awaited<ReturnType<typeof clinicsVerificationState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicsVerificationState<TData = Awaited<ReturnType<typeof clinicsVerificationState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت تأیید مدارک
 */

export function useClinicsVerificationState<TData = Awaited<ReturnType<typeof clinicsVerificationState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicsVerificationState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicsVerificationStateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * شمارهٔ پروانه و مدارک بارگذاری‌شده را برای بررسی مدیر سامانه ثبت می‌کند و کلینیک را به وضعیت «در انتظار بررسی» می‌برد. دست‌کم یک مدرک از نوع «پروانهٔ پزشکی» الزامی است.
 * @summary ارسال مدارک برای بررسی
 */
export const clinicsSubmitVerification = (
    submitVerificationDto: SubmitVerificationDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicVerificationResponse>(
      {url: `/api/v1/clinics/current/verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitVerificationDto, signal
    },
      );
    }




export const getClinicsSubmitVerificationMutationKey = () => ['clinicsSubmitVerification'] as const;

export const getClinicsSubmitVerificationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsSubmitVerification>>, TError,ClinicsSubmitVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsSubmitVerification>>, TError,ClinicsSubmitVerificationMutationVariables, TContext> => {

const mutationKey = getClinicsSubmitVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsSubmitVerification>>, ClinicsSubmitVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsSubmitVerification(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsSubmitVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsSubmitVerification>>>
    export type ClinicsSubmitVerificationMutationBody = SubmitVerificationDto
    export type ClinicsSubmitVerificationMutationError = void
    export type ClinicsSubmitVerificationMutationVariables = {data: SubmitVerificationDto}

    /**
 * @summary ارسال مدارک برای بررسی
 */
export const useClinicsSubmitVerification = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsSubmitVerification>>, TError,ClinicsSubmitVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsSubmitVerification>>,
        TError,
        ClinicsSubmitVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsSubmitVerificationMutationOptions(options), queryClient);
    }
    /**
 * یک نشانی امضاشده برای PUT مستقیم فایل برمی‌گرداند. کلید فایل را سرور می‌سازد؛ فایل در فضای خصوصی ذخیره می‌شود و هیچ نشانی عمومی ندارد.
 * @summary گرفتن نشانی بارگذاری مدرک
 */
export const clinicsVerificationUploadUrl = (
    verificationUploadUrlDto: VerificationUploadUrlDto,
 signal?: AbortSignal
) => {


      return apiClient<UploadTicketResponse>(
      {url: `/api/v1/clinics/current/verification/upload-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationUploadUrlDto, signal
    },
      );
    }




export const getClinicsVerificationUploadUrlMutationKey = () => ['clinicsVerificationUploadUrl'] as const;

export const getClinicsVerificationUploadUrlMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>, TError,ClinicsVerificationUploadUrlMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>, TError,ClinicsVerificationUploadUrlMutationVariables, TContext> => {

const mutationKey = getClinicsVerificationUploadUrlMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>, ClinicsVerificationUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicsVerificationUploadUrl(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicsVerificationUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>>
    export type ClinicsVerificationUploadUrlMutationBody = VerificationUploadUrlDto
    export type ClinicsVerificationUploadUrlMutationError = void
    export type ClinicsVerificationUploadUrlMutationVariables = {data: VerificationUploadUrlDto}

    /**
 * @summary گرفتن نشانی بارگذاری مدرک
 */
export const useClinicsVerificationUploadUrl = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>, TError,ClinicsVerificationUploadUrlMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicsVerificationUploadUrl>>,
        TError,
        ClinicsVerificationUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getClinicsVerificationUploadUrlMutationOptions(options), queryClient);
    }
